"use client";

import type { ReactNode } from "react";

import { createInstance, type Resource } from "i18next";
import { I18nextProvider } from "react-i18next";

import i18n from "@/shared/config/i18n/client";
import type { AppLanguage } from "@/shared/config/i18n/config";

type PublicI18nBoundaryProps = {
  readonly children: ReactNode;
  readonly locale: AppLanguage;
  readonly resources: Resource[string];
};

export function PublicI18nBoundary({ children, locale, resources }: PublicI18nBoundaryProps) {
  // Prerendered routes may overlap; never share their mutable language state.
  const pageI18n = typeof window === "undefined" ? createInstance() : i18n;
  if (!pageI18n.isInitialized) {
    void pageI18n.init({
      lng: locale,
      resources: { [locale]: resources },
      initAsync: false,
      interpolation: { escapeValue: false },
    });
  }

  if (!pageI18n.exists("landing.hero.title1", { lng: locale })) {
    pageI18n.addResourceBundle(locale, "translation", resources.translation, true, true);
  }

  if (pageI18n.resolvedLanguage !== locale) {
    void pageI18n.changeLanguage(locale);
  }

  return <I18nextProvider i18n={pageI18n}>{children}</I18nextProvider>;
}
